import React, { memo } from 'react';
import './Skeleton.css';

/**
 * Primitive Skeleton component with modern CSS shimmer animation.
 * Prevents layout shifts and complies with accessibility guidelines (aria-hidden).
 */
const Skeleton = memo(function Skeleton({
  variant = 'rectangular',
  width,
  height,
  borderRadius,
  className = '',
  style = {},
  ...props
}) {
  const customStyle = { ...style };

  if (width !== undefined) {
    customStyle.width = typeof width === 'number' ? `${width}px` : width;
  }
  if (height !== undefined) {
    customStyle.height = typeof height === 'number' ? `${height}px` : height;
  }
  if (borderRadius !== undefined) {
    customStyle.borderRadius = typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius;
  }

  const variantClass = `skeleton-${variant}`;

  return (
    <span
      className={`skeleton-box ${variantClass} ${className}`.trim()}
      style={customStyle}
      aria-hidden="true"
      {...props}
    />
  );
});

export default Skeleton;
